import React, { useState, useEffect } from 'react';
import './OutsideTypeButtons.scss';
import { typeButtonsData } from './typebuttons-data';

const OutsideTypeButtons = ({ onSelect, currentPano }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (currentPano?._id) {
      const foundIndex = typeButtonsData.findIndex((item) =>
        item.objects.some((obj) => obj.id === currentPano._id)
      );
      if (foundIndex !== -1) {
        setActiveIndex(foundIndex);
      }
    }
  }, [currentPano]);

  const handleSelect = (item, index) => {
    setActiveIndex(index);
    onSelect(item);
  };

  return (
    <div className="outside-type--buttons">
      {typeButtonsData.map((item, index) => (
        <button
          key={index}
          className={`outside-type--button ${
            activeIndex === index ? 'active' : ''
          }`}
          onClick={() => handleSelect(item, index)}
        >
          {item.image.name}
        </button>
      ))}
    </div>
  );
};

export default OutsideTypeButtons;
